import type {} from "@lit/react";
import { SelectItem as SelectItemElement, } from "@vaadin/select/vaadin-select-item.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { SelectItemElement };
export type SelectItemEventMap = Readonly<{}>;
const events = {} as SelectItemEventMap;
export type SelectItemProps = WebComponentProps<SelectItemElement, SelectItemEventMap>;
export const SelectItem = createComponent({
    elementClass: SelectItemElement,
    events,
    react: React,
    tagName: "vaadin-select-item",
});
